import React from "react";
import { motion } from "framer-motion";

const items = [
  { emoji: "📲", title: "SMS parsing", desc: "Auto-read transaction SMS to track spends (on-device)." },
  { emoji: "📊", title: "Smart categories", desc: "Expenses grouped automatically — food, transport, subscriptions." },
  { emoji: "🔔", title: "Budget nudges", desc: "Friendly reminders before you go over budget." },
  { emoji: "💡", title: "AI tips", desc: "Personalized saving suggestions for students." },
  { emoji: "🤝", title: "Split bills", desc: "Easily split and settle with friends." },
  { emoji: "🏆", title: "Rewards", desc: "Gamified referrals and campus perks." },
];

export default function Features(){
  return (
    <section id="features" className="py-10">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-2xl font-bold">Features that actually help</h3>
        <p className="mt-2 text-gray-600 dark:text-gray-300">Simple, student-first features that get used daily.</p>

        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((f, i) => (
            <motion.div
              key={i}
              initial={{opacity:0, y:12, scale: 0.99}}
              whileInView={{opacity:1, y:0, scale:1}}
              viewport={{once:true}}
              transition={{delay: i * 0.06, duration: 0.5}}
              className="p-5 rounded-xl glass border border-gray-100 dark:border-gray-800 shadow neon-hover"
              whileHover={{ translateY: -6, boxShadow: "0 20px 60px rgba(6,182,212,0.12)" }}
            >
              <div className="text-3xl">{f.emoji}</div>
              <h4 className="mt-3 font-semibold">{f.title}</h4>
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{f.desc}</p>
              <div className="mt-4">
                <button className="text-sm px-3 py-2 rounded-full border border-transparent hover:border-[#06b6d4] hover:text-[#06b6d4] transition">Learn more →</button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
